import { combineReducers } from "redux"
import { reducer as formReducer } from "redux-form"
import { routerReducer } from "react-router-redux"
import { reducer } from 'redux-oidc'
import modals from "../ducks/modals"
import { formsReducer } from './formsReducer'
import user from './reducer_user'


// import ui from "ducks/ui";
export const reducers = combineReducers({
  modals,
  form: formReducer.plugin(formsReducer),
  routing: routerReducer,
  oidc:reducer,
  user
})



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js